module.exports = __webpack_public_path__ + "media/images/wia-5808772e64e68e5bd83012804f339294.svg";